import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VideoList from './components/VideoList';
import AppShell from './components/AppShell';
import VideoUpload from './components/VideoUpload';
import VideoPlayerWithSubtitles from './components/VideoPlayerWithSubtitles';
import Login from './components/Login';
import LoginMethod from './components/LoginMethod';
import WeChatQrLogin from './components/WeChatQrLogin';
import WeChatLoginDone from './components/WeChatLoginDone';
import Register from './components/Register';
import MyPage from './components/MyPage';
import UserProfileEdit from './components/UserProfileEdit';
import ChangePassword from './components/ChangePassword';
import Settings from './components/Settings';
import ThemeEdit from './components/ThemeEdit';
import LanguageSettings from './components/LanguageSettings';
import ContactUs from './components/ContactUs';
import RefreshPage from './components/RefreshPage';
// 暂时注释掉未使用的组件，后续可能需要
import VideoEdit from './components/VideoEdit';
import SubtitleEditor from './components/SubtitleEditor';
import CollectionEdit from './components/CollectionEdit';
import CollectionDetail from './components/CollectionDetail';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import { initViewportHeight } from './utils/viewportHeight';
import { initKuromoji } from './utils/kuromojiManager';
import './App.css';

// 初始化动态视口高度管理（智能：优先CSS方案，JS兜底）
initViewportHeight();

// 初始化 Kuromoji 分词器（全局单例，应用启动时初始化一次）
initKuromoji();

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sign-in" element={<LoginMethod />} />
          <Route path="/sign-in/wechat-qr" element={<WeChatQrLogin />} />
          <Route path="/login/wechat-done" element={<WeChatLoginDone />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <Layout>
                <AppShell>
                  <VideoList />
                </AppShell>
              </Layout>
            }
          />
          
          {/* /upload 现在是独立的"新建视频"页面：VideoUpload 自带 AppShell + 顶栏，
              这里不再叠加外层 Layout / AppShell，避免双重外壳 */}
          <Route
            path="/upload"
            element={
              <ProtectedRoute>
                <VideoUpload />
              </ProtectedRoute>
            }
          />
          <Route
            path="/player"
            element={
              <ProtectedRoute>
                <Layout showBottomNav={false}>
                  <VideoPlayerWithSubtitles />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <Layout>
                <AppShell>
                  <MyPage />
                </AppShell>
              </Layout>
            }
          />
          <Route
            path="/profile/edit"
            element={
              <ProtectedRoute>
                <UserProfileEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/settings/theme"
            element={
              <ProtectedRoute>
                <ThemeEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/settings/language"
            element={
              <ProtectedRoute>
                <LanguageSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/settings/refresh"
            element={
              <ProtectedRoute>
                <RefreshPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/settings/contact-us"
            element={
              <ProtectedRoute>
                <ContactUs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/video/edit"
            element={
              <ProtectedRoute>
                <VideoEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/video/edit/subtitles"
            element={
              <ProtectedRoute>
                <SubtitleEditor />
              </ProtectedRoute>
            }
          />
          {/* 视频合集相关路由 */}
          <Route
            path="/collections/new"
            element={
              <ProtectedRoute>
                <CollectionEdit mode="create" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/collections/:collectionId/edit"
            element={
              <ProtectedRoute>
                <CollectionEdit mode="edit" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/collections/:collectionId"
            element={
              <ProtectedRoute>
                <Layout>
                  <CollectionDetail />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* 暂时隐藏的功能，后面再加回来 */}
          {/* <Route
            path="/history"
            element={
              <ProtectedRoute>
                <Layout>
                  <VideoHistory />
                </Layout>
              </ProtectedRoute>
            }
          /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
